'use client'
import { useEffect, useRef, useState } from 'react'
import { Play } from 'lucide-react'

const HLS_SRC = 'https://eme-knowledge-hls.s3.us-east-1.amazonaws.com/microsaas/TEASER+APEX+V3/TEASER+APEX+V3.m3u8'

export const HeroVideo = () => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [playing, setPlaying] = useState(false)
  const [hlsLoaded, setHlsLoaded] = useState(false)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = HLS_SRC
      setHlsLoaded(true)
    } else {
      import('hls.js').then(({ default: Hls }) => {
        if (Hls.isSupported()) {
          const hls = new Hls()
          hls.loadSource(HLS_SRC)
          hls.attachMedia(video)
          hls.on(Hls.Events.MANIFEST_PARSED, () => setHlsLoaded(true))
          return () => hls.destroy()
        }
      })
    }
  }, [])

  const handlePlay = () => {
    const video = videoRef.current
    if (!video) return
    video.play()
    setPlaying(true)
  }

  const handlePause = () => {
    setPlaying(false)
  }

  return (
    <div className="relative w-full">
      <div className="relative rounded-2xl overflow-hidden border border-gray-200 shadow-[0_8px_60px_rgba(57,131,247,0.18)] bg-[#0d0d0d]">
        <div className="flex items-center gap-1.5 px-4 py-3 bg-[#111111] border-b border-white/5">
          <span className="w-3 h-3 rounded-full bg-[#FF5F57]" />
          <span className="w-3 h-3 rounded-full bg-[#FEBC2E]" />
          <span className="w-3 h-3 rounded-full bg-[#28C840]" />
          <span className="ml-3 flex-1 bg-white/5 rounded-md h-5 max-w-xs text-xs text-white/30 flex items-center px-3">
            achieveapex.com
          </span>
        </div>

        <div className="relative w-full aspect-video bg-[#0d0d0d]">
          <video
            ref={videoRef}
            controls={playing}
            playsInline
            onPause={handlePause}
            onEnded={handlePause}
            className="absolute inset-0 block h-full w-full object-contain"
          />

          {!playing && (
            <div
              className="absolute inset-0 flex flex-col items-center justify-center bg-black/50 cursor-pointer group"
              onClick={handlePlay}
            >
              <div className="flex h-16 w-16 items-center justify-center rounded-full border border-white/20 bg-white/10 shadow-[0_0_40px_rgba(57,131,247,0.5)] md:h-20 md:w-20 md:group-hover:scale-110 md:group-hover:bg-white/20">
                <Play className="w-7 h-7 md:w-9 md:h-9 text-white fill-white ml-1" />
              </div>
              <p className="mt-4 text-white/70 text-sm md:text-base font-medium tracking-wide">
                Ver el demo
              </p>
            </div>
          )}
        </div>

        <div className="absolute inset-0 rounded-2xl pointer-events-none ring-1 ring-inset ring-white/5" />
      </div>

      <div className="absolute -inset-1 rounded-3xl bg-gradient-to-br from-blue-100/60 to-transparent blur-2xl -z-10 pointer-events-none" />
    </div>
  )
}
